<div class="pills">
  <!-- Order of pills is: 
   1. Insurance if selected
   2. Specialties 
   3. General insurance acceptance
   4. Session types 
  -->
  <pill
    *ngIf="insuranceName | async"
    icon="verified_user"
    [displayText]="'Accepts ' + (insuranceName | async)"
  />
  <pill 
    *ngFor="let name of specialtyNames | async"
    icon="check_circle"
    [displayText]="name"
  />
  <pill
    *ngIf="!(insuranceName | async) && providerInsurances && providerInsurances.length > 0"
    icon="verified_user"
    displayText="Accepts insurance"
  />
  <pill
    *ngIf="offersInPerson"
    icon="location_on"
    [displayText]="longSessionTypesDisplayText ? 'In-person sessions' : 'In-person'"
  />
  <pill
    *ngIf="offersVideo"
    icon="videocam"
    [displayText]="longSessionTypesDisplayText ? 'Video sessions' : 'Video'"
  />
</div>